import { makeApiCall } from '../../../../services/apiService/apiService';
import { clientAppUuid } from '../../../../services/helpers';
import { toastr } from 'react-redux-toastr';

const headersData = { appUuid: clientAppUuid };

export const airflowActions = {
  SET_SUBMIT_LOADER: 'SET_SUBMIT_LOADER'
};

export const getSubmitLoaderAction = load => {
  return {
    type: airflowActions.SET_SUBMIT_LOADER,
    payload: load
  };
};

export const submitBarcodes = (
  dataToSend,
  successCallback,
  failureCallback
) => (dispatch: Function) => {
  dispatch(getSubmitLoaderAction({ isSubmitInProgress: true }));

  const requestObj = {
    baseUrl: 'clientIntegrationApiUrl',
    apiEndPoint: 'airflowSubmitConsignments',
    method: 'POST',
    data: dataToSend,
    headersData,
    notShowPopupOnError: true,
    successCb: res => {
      if (res.status === 'SUCCESS') {
        dispatch(getSubmitLoaderAction({ isSubmitInProgress: false }));

        if (!res.payload.failedLrs || res.payload.failedLrs.length == 0) {
          toastr.warning('Check Bulk CN Tool For CN Creation');
        } else {
          toastr.error(`Data not found for ${res.payload.failedLrs.length} LR's.
          Cannot create CNs until data is available for all LR numbers 
          Please edit/delete the incorrect LR numbers to proceed.'`);
        }
        if (successCallback) {
          successCallback(res.payload);
        }
      } else if (res.status === 'FAILURE') {
        dispatch(getSubmitLoaderAction({ isSubmitInProgress: false }));
        toastr.error('Error', res.errorMessage || 'Something went wrong');
        if (failureCallback) {
          failureCallback();
        }
      }
    },
    failureCb: res => {
      dispatch(getSubmitLoaderAction({ isSubmitInProgress: false }));
      toastr.error('something went wrong', 'error', 'Error');
      if (failureCallback) {
        failureCallback();
      }
    },
    catchCb: res => {
      dispatch(getSubmitLoaderAction({ isSubmitInProgress: false }));
      toastr.error('something went wrong', 'error', 'Error');
      if (failureCallback) {
        failureCallback();
      }
    }
  };

  return makeApiCall(requestObj);
};
